import "./Carousel.css";

import { billers } from "../../billers";

const Carousel = () => {
  const onViewBillersClicked = () => {};
  return (
    <div className="carousel-container">
      <div className="carousel-divider" />
      <div className="carousel-text">
        <p className="carousel-title">
          Need to pay something other than a CoCT Fine?
        </p>
        <p className="carousel-subtitle">
          Simply visit the Pay@ website using the button below:
        </p>
      </div>
      <div className="carousel-images">
        {billers
          .concat(billers)
          .concat(billers)
          .map((e, index) => (
            <img key={index} className="biller" src={e} />
          ))}
      </div>

      <a
        target="_blank"
        href="https://payat.co.za/billers/"
        className="view-billers-button"
        onClick={onViewBillersClicked}
      >
        <p>View Pay@ Billers</p>
      </a>
    </div>
  );
};

export default Carousel;
